import NoteIcon from '@mui/icons-material/Note';
import { Button, Typography, useTheme } from '@mui/material';

const ATTIO_WORKSPACE = 'scalar-valuation';

export type AttioNotesObject = 'company' | 'person';

export const getAttioNotesUrl = (object: AttioNotesObject, recordId: string) =>
  `https://app.attio.com/${ATTIO_WORKSPACE}/${object}/${recordId}/notes`;

interface AttioNotesButtonProps {
  recordId?: string;
  object: AttioNotesObject;
  hasNotes: boolean;
}

const AttioNotesButton = ({ recordId, object, hasNotes }: AttioNotesButtonProps) => {
  const theme = useTheme();
  
  return (
    <Button
      variant="outlined"
      disabled={!hasNotes || !recordId}
      size="small"
      sx={{
        width: '90px',
        padding: 0,
        margin: 0,
        gap: '0.5rem',
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.primary.main}`,
        textTransform: 'none',
        '& .MuiTypography-root': {
          color: theme.palette.primary.main,
        },
        '&.Mui-disabled': {
          border: `1px solid ${theme.palette.primary.main} !important`,
        },
      }}
      onClick={() => {
        if (recordId) {
          window.open(getAttioNotesUrl(object, recordId), '_blank');
        }
      }}
    >
      <Typography variant="body2" sx={{ color: theme.palette.primary.main, fontWeight: 600 }}>Notes</Typography>
      <NoteIcon sx={{ color: theme.palette.primary.main }} />
    </Button>
  )
}
export default AttioNotesButton;
